import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

import OrgBrand from '../OrgBrand';

export default function Navbar() {
  return (
    <nav className="top-0  absolute z-50 w-full flex flex-wrap items-center justify-between  navbar-expand-lg">
      <div className="container px-4 py-2 mx-auto flex flex-wrap items-center justify-between ">
        <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
          <Link
            className="text-gray-600 text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-no-wrap uppercase"
            to="/"
          >
            CORE PLANE ERP
          </Link>
        </div>
        {/* โลโก้/ชื่อบริษัทจาก org/ — ตำแหน่งใหม่ฝั่งขวา แยกจากข้อความ CORE PLANE ERP ด้านซ้าย
            ไม่มีไฟล์/ชื่อ = ไม่แสดงอะไร */}
        <div className="py-2 text-gray-600 text-sm font-bold">
          <OrgBrand logoHeight={32} logoSx={{ borderRadius: 2 }} />
        </div>
      </div>
    </nav>
  );
}
